<template>

<core-modal-setting :title="(isPlaceholder) ? 'Restrict Sorts' : 'Sorts'" :value="valueText" :placeholder="(isPlaceholder) ? 'All sorts' : 'Always shown'">
        
    <core-input-multiselect :options="options" v-model="internalValue" placeholder="Search sorts..." />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'
import $sort from '@/sort'

export default {

    mixins: [mixSetting],

    props: ['field'],

    data: function() {

        return {
            noun: 'sort'
        }

    },

    computed: {

        isPlaceholder: function() {

            return this.field.key === 'dynamic.placeholder'

        },

        options: function() {

            var options = []

            this.$_.each($sort.types, function(type) {

                options.push({
                    value: type.key,
                    text: type.lang.name
                })

            })

            return options

        }

    }

}

</script>

<style scoped>

</style>